'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' });

var LooksTwo = function LooksTwo(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

LooksTwo = (0, _pure2.default)(LooksTwo);
LooksTwo.muiName = 'SvgIcon';

exports.default = LooksTwo;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/LooksTwo.js
// module id = 2597
// module chunks = 0